import { render, staticRenderFns } from "./PresentationEditor.vue?vue&type=template&id=e5bf6ba2&scoped=true&"
import script from "./PresentationEditor.vue?vue&type=script&lang=js&"
export * from "./PresentationEditor.vue?vue&type=script&lang=js&"
import style0 from "./PresentationEditor.vue?vue&type=style&index=0&id=e5bf6ba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bf6ba2",
  null
  
)

export default component.exports